module.exports = __webpack_public_path__ + "static/img/title-dpmc-new.45937220.png";